import { Module } from 'vuex';
import { RootState, getAbsolutePath } from './index'
import { Template } from './types/templates';
import { addDoc, updateDoc, collection, doc, onSnapshot, orderBy, query, serverTimestamp, deleteDoc, DocumentReference } from 'firebase/firestore';
import { db } from '@/firebase';
import { Unsubscribe } from 'firebase/auth';
import { firebase } from './firebase';

export interface TemplateState {
  templates?: Template[];
  privateTemplates?: Template[];
}

// スナップショットの解除用
let unsubscribeTemplates: (() => void) | undefined = undefined;
let unsubscribePrivateTemplates: (() => void) | undefined = undefined;


export const templates: Module<TemplateState, RootState> = {

  state: {
    templates: undefined,
    privateTemplates: undefined,
  },

  getters: {
    rootState: (state, getters, rootState) => rootState,
  },

  mutations: {

    // テンプレートの設定
    setTemplates(state, params: { templates: Template[], isPrivate?: boolean }) {
      console.log('setTemplates init', params);
      const templates = params.templates;
      const isPrivate = params.isPrivate ?? false;
      // console.log('setTemplates templates', templates);
      console.log(
        'setTemplates [0].title', templates[0]?.title,
        'isPrivate', isPrivate
      );
      if (isPrivate) {
        console.log('setTemplates isPrivate');
        state.privateTemplates = templates;
      } else {
        console.log('setChatSummaries not isPrivate');
        state.templates = templates;
      }
    },

    // テンプレートのクリア
    clearTemplates(state, isPrivate = false) {
      console.log('clearTemplates');
      if (isPrivate) {
        state.privateTemplates = undefined;
      } else {
        state.templates = undefined;
      }
    },

    // onSnapshot処理におけるテンプレートの要素追加
    addTemplates(state, params: { templates: Template[], isPrivate?: boolean }) {
      console.log('addTemplate', params);
      const templates = params.templates;
      const isPrivate = params.isPrivate ?? false;
      if (isPrivate) {
        if (state.privateTemplates === undefined) {
          state.privateTemplates = templates;
        } else {
          state.privateTemplates = [...templates].concat(state.privateTemplates);
        }
      } else {
        if (state.templates === undefined) {
          state.templates = templates;
        } else {
          state.templates = [...templates].concat(state.templates);
        }
      }
    },

    // onSnapshot処理におけるテンプレートの要素更新処理
    updateTemplates(state, params: { templates: Template[], isPrivate?: boolean }) {
      console.log('updateTemplate', params);
      const updatedTemplates = params.templates;
      const isPrivate = params.isPrivate ?? false;
      const templates = isPrivate ? state.privateTemplates : state.templates;

      if (templates === undefined) {
        if (isPrivate)
          state.privateTemplates = templates;
        else
          state.templates = templates;
      } else {
        const newTemplates = templates.map(template => {
          const index = updatedTemplates?.findIndex(
            t => t.id === template.id
          );
          // 一致するものがあれば更新
          if (index !== undefined && index >= 0)
            return updatedTemplates[index];
          else
            // なければそのまま
            return template;
        });
        if (isPrivate)
          state.privateTemplates = newTemplates;
        else
          state.templates = newTemplates;
      }
    },

    // onSnapshot処理におけるテンプレートの要素削除処理
    removeTemplates(state, params: { templates: Template[], isPrivate?: boolean }) {
      console.log('deleteTemplates', params);
      const deletedTemplates = params.templates;
      const isPrivate = params.isPrivate ?? false;
      const templates = isPrivate ? state.privateTemplates : state.templates;

      if (templates === undefined) {
        if (isPrivate)
          state.privateTemplates = templates;
        else
          state.templates = templates;
      } else {
        const newTemplates = templates.filter(template => {
          const index = deletedTemplates?.findIndex(
            t => t.id === template.id
          );
          // 一致するものがあれば削除
          if (index !== undefined && index >= 0)
            return false;
          else
            // なければそのまま
            return true;
        });
        if (isPrivate)
          state.privateTemplates = newTemplates;
        else
          state.templates = newTemplates;
      }
    },

  },

  // 非同期処理
  actions: {

    // FirestoreからTemplatesの一覧を取得する
    async subscribeTemplates({ commit, rootState }, isPrivate = false)
      : Promise<Unsubscribe> {

      console.log('subscribeTemplates', isPrivate);
      const colRef = collection(db, getAbsolutePath(isPrivate, rootState, 'templates'));
      const q = query(colRef, orderBy('created', 'asc'));
      const unsubscribe = onSnapshot(q, (snapshot) => {
        // 更新があった場合に反映
        const addedTemplates: Template[] = [];
        const updatedTemplates: Template[] = [];
        const removedTemplates: Template[] = [];

        console.log('subscribeTemplates onSnapshot');
        snapshot.docChanges().forEach((change) => {
          console.log('subscribeTemplates onSnapshot change', change);
          const template = change.doc.data() as Template;
          template.id = change.doc.id;
          template.is_public = !isPrivate;
          switch (change.type) {
            case 'added':
              addedTemplates.push(template);
              break;
            case 'modified':
              updatedTemplates.push(template);
              break;
            case 'removed':
              removedTemplates.push(template);
              break;
            default:
              console.log('change.type is unknown', change.type);
          }
        });
        commit('addTemplates', { templates: addedTemplates, isPrivate });
        commit('updateTemplates', { templates: updatedTemplates, isPrivate });
        commit('removeTemplates', { templates: removedTemplates, isPrivate });
      });

      if (isPrivate)
        unsubscribePrivateTemplates = unsubscribe;
      else
        unsubscribeTemplates = unsubscribe;
      return unsubscribe;
    },
    // Firestoreにテンプレートを新規登録する
    async addTemplate({ rootState }, params: { template: Template, isPrivate: boolean }): Promise<DocumentReference> {
      const template = params.template;
      const isPrivate = params.isPrivate ?? false;

      // タイムスタンプの付与
      template.created = serverTimestamp();
      template.modified = serverTimestamp();      

      console.log('addTemplate', template, isPrivate);
      const templatesRef = collection(db, getAbsolutePath(isPrivate, rootState, 'templates'));
      return await addDoc(templatesRef, template);
    },
    // Firestore上でテンプレートを更新する
    async updateTemplate({ rootState }, params: { template: Template, isPrivate: boolean }): Promise<void> {
      const template = params.template;
      const isPrivate = params.isPrivate ?? false;

      // タイムスタンプの付与
      template.modified = serverTimestamp();

      console.log('updateTemplate', template, isPrivate);
      const templateRef = doc(db, getAbsolutePath(isPrivate, rootState, 'templates/' + template.id),);
      await updateDoc(templateRef, template);
    },

    // FirestoreからTemplateを削除する
    async deleteTemplate({ rootState }, params: { template: Template, isPrivate: boolean }): Promise<void> {
      const template = params.template;
      const isPrivate = params.isPrivate ?? false;

      console.log('deleteTemplate', template, isPrivate);
      const templateRef = doc(db, getAbsolutePath(isPrivate, rootState, 'templates/' + template.id),);
      await deleteDoc(templateRef);
    },
    // テンプレート文字列の変換
    convertTemplate({state, rootState}, templateStr: string): string {
      // '{{'と'}}'で囲まれた文字列を変換する
      
      // 辞書データでテンプレート文字列の変換関数を表す
      const replacedFunctions:{[key: string]: () => string} = 
        {
          // ユーザー名
          username: () => rootState.firebase.user?.displayName ?? '',
          date: () => new Date().toLocaleDateString(),
          time: () => new Date().toLocaleTimeString(),
          datetime: () => new Date().toLocaleString(),
        }
 
      const templateRegex = /{{(.+?)}}/g;
      // テンプレート文字列の変換
      
      const convertedStr = templateStr.replace(templateRegex, (match, p1) => {
        const replacedFunction = replacedFunctions[p1.trim()];
        if (replacedFunction !== undefined)
          return replacedFunction();
        else
          return match;
      });
      
      return convertedStr;
    },
  },
};